import type { TCell } from "@/constants/regions";

import { SubscriptionItemType } from "@/primary-models";

/**
 * The item types each cell sells. This is the single source of truth for what can be
 * selected in a cell: anything not listed here is rejected by the subscriptions service.
 *
 * Backend callers pass `getCell()`.
 */
export const CELL_AVAILABLE_ITEM_TYPES: Record<TCell, readonly SubscriptionItemType[]> = {
  // Scoop Health is not sold in any cell
  uk: Object.values(SubscriptionItemType).filter((type) => type !== SubscriptionItemType.SCOOP_HEALTH),
  de: [
    // Fresh: chunky only, no shredded or smooth
    SubscriptionItemType.CLUCK,
    SubscriptionItemType.GOBBLE,
    SubscriptionItemType.MOOO,
    SubscriptionItemType.SWISH,
    SubscriptionItemType.SPLASH,
    // Pantry: no nibbles tubes and no litter
    SubscriptionItemType.SPRINKLES,
    SubscriptionItemType.NIBBLES_CHICKEN_POUCH,
    SubscriptionItemType.NIBBLES_SALMON_POUCH,
    SubscriptionItemType.NIBBLES_TUNA_POUCH,
  ],
};

export const getAvailableItemTypes = (cell: TCell): readonly SubscriptionItemType[] => (
  CELL_AVAILABLE_ITEM_TYPES[cell]
);

export const isItemTypeAvailableInCell = (itemType: string, cell: TCell): boolean => (
  (CELL_AVAILABLE_ITEM_TYPES[cell] as readonly string[]).includes(itemType)
);
